export default "__VITE_ASSET__DCx$goD6__"